import React from 'react';

import { Icon as ChakraIcon } from '@chakra-ui/react';

import { IconProps } from '../../icon/types';

export const MuIcon = (props: IconProps) => (
  <ChakraIcon
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 640 480"
    {...props}
  >
    <g fillRule="evenodd">
      <path fill="#00a04d" d="M0 360h640v120H0z" />
      <path fill="#151f6d" d="M0 120h640v120H0z" />
      <path fill="#ee2737" d="M0 0h640v120H0z" />
      <path fill="#ffcd00" d="M0 240h640v120H0z" />
    </g>
  </ChakraIcon>
);
